import { APIEndpoints } from "@/utils/APIEndpoints";
import { riccAPI } from "./APIService";

riccAPI.injectEndpoints({
  endpoints: (builder) => ({
    //get product details on landing page
    productDetails: builder.query({
      query: ({ productSponsorId }) => ({
        url: APIEndpoints.productDetails,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
      providesTags: ["product"],
    }),
    //get product details on landing page
    transactionType: builder.query({
      query: () => ({
        url: APIEndpoints.getAllTransactionType,
        method: "GET",
      }),
      providesTags: ["product"],
    }),

    // Get specific record system
    searchRecordKeeperName: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.searchRecordKeepingSystem,
        method: "POST",
        body: payload,
      }),
      providesTags: ["product"],
    }),

    // Get specific record system transaction matrix
    getTransactionMatrix: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getTransactionMatrix,
        method: "POST",
        body: payload,
      }),
      providesTags: ["product"],
    }),
    // Get specific record system transaction matrix
    saveTransactionMatrixEntryTransaction: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.saveTransactionMatrixEntryTransaction,
        method: "POST",
        body: payload,
      }),
      providesTags: ["product"],
    }),

    //get insuranceCompanies getInsuranceCompanies
    insuranceCompanies: builder.mutation({
      query: ({ productSponsorId, productId }) => ({
        url: APIEndpoints.getInsuranceCompanies,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
          productId: productId,
        },
      }),
    }),

    // Get Product Rules
    getProductRules: builder.query({
      query: ({ productSponsorId, productId }) => ({
        url: APIEndpoints.productRules,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
          productId: productId,
        },
      }),
      providesTags: ["productRules"],
    }),
    // Save Product Rules
    saveProductRules: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productRules,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["productRules"],
    }),

    // Get All Insurance Companies
    getAllInsuranceCompanies: builder.query({
      query: ({ productSponsorId }) => ({
        url: APIEndpoints.allInsuranceCompanies,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
    }),
    // Get Insurance Companies for a Product
    getProductInsuranceCompanies: builder.query({
      query: ({ productSponsorId, productId }) => ({
        url: APIEndpoints.productInsuranceCompanies,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
          productId: productId,
        },
      }),
      providesTags: ["productInsurances"],
    }),
    // Save Insurance Company for a Product
    saveProductInsuranceCompanies: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productInsuranceCompanies,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["productInsurances", "product"],
    }),

    // Get Payment Table
    getPaymentTable: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.paymentTable,
        method: "POST",
        body: payload,
      }),
    }),
    // Get Payment Table Audit
    getPaymentTableAudit: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.paymentTableAudit,
        method: "POST",
        body: payload,
      }),
    }),
    // Save/Update Payment Table
    updatePaymentTable: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.paymentTable,
        method: "PUT",
        body: payload,
      }),
    }),

    // Get Payment Table for gmwbCalculation type T
    getWithdrawalTable: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.withdrawalTable,
        method: "POST",
        body: payload,
      }),
    }),
    // Save/Update Payment Table for gmwbCalculation type T
    updateWithdrawalTable: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.withdrawalTable,
        method: "PUT",
        body: payload,
      }),
    }),

    // Get Contact And Certificate
    getContractAndCertificate: builder.query({
      query: ({ productSponsorId, productId }) => ({
        url: APIEndpoints.contractCertificate,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
          productId: productId,
        },
      }),
      providesTags: ["contractCertificate"],
    }),
    // Save Contact And Certificate
    saveContractAndCertificate: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.contractCertificate,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["contractCertificate"],
    }),

    // Get Insurance Companies for a Product
    getAccountBalance: builder.query({
      query: ({ productSponsorId, productId }) => ({
        url: APIEndpoints.checkAccountBalance,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
          productId: productId,
        },
      }),
    }),
    // Update Product Details
    updateProductDetails: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.addUpdateProduct,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["product"],
    }),
    // Update Product Details
    saveProductDetails: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.addUpdateProduct,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["product"],
    }),
    // Get Purchase Table
    getPurchaseTable: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.purchaseTable,
        method: "POST",
        body: payload,
      }),
    }),
    // Save/Update Purchase Table
    updatePurchaseTable: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.purchaseTable,
        method: "PUT",
        body: payload,
      }),
    }),
    // Get Purchase Table Audit
    getPurchaseTableHistory: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getPurchaseTableHistory,
        method: "POST",
        body: payload,
      }),
    }),

    //Get Investment Companies
    getInvestmentCompanies: builder.query({
      query: (productSponsorId) => ({
        url: APIEndpoints.productInvestmentCompanies,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
    }),
    //Get All Investment Vehicles
    getAllInvestmentVehiclesForProduct: builder.query({
      query: (productSponsorId) => ({
        url: APIEndpoints.allInvestmentVehicles,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
    }),
    //Get Investment Vehicles
    getInvestmentVehiclesForProduct: builder.query({
      query: ({ productSponsorId, productId }) => ({
        url: APIEndpoints.productInvestmentVehicles,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
          productId: productId,
        },
      }),
      providesTags: ["invVehicle"],
    }),
    //Save product investment vehicles
    saveProductInvestmentVehicles: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productInvestmentVehicles,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["product", "invVehicle"],
    }),
    //Get Investment Vehicles Audit History
    productInvestmentVehiclesAudit: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productInvestmentVehiclesAudit,
        method: "POST",
        body: payload,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useProductDetailsQuery,
  useInsurersMutation,
  useSearchRecordKeeperNameMutation,
  useTransactionTypeQuery,
  useGetProductRulesQuery,
  useSaveProductRulesMutation,
  useGetTransactionMatrixMutation,
  useGetAllInsuranceCompaniesQuery,
  useGetProductInsuranceCompaniesQuery,
  useSaveProductInsuranceCompaniesMutation,
  useSaveTransactionMatrixEntryTransactionMutation,
  useGetPaymentTableMutation,
  useGetPaymentTableAuditMutation,
  useUpdatePaymentTableMutation,

  useGetWithdrawalTableMutation,
  useUpdateWithdrawalTableMutation,

  useGetContractAndCertificateQuery,
  useSaveContractAndCertificateMutation,

  useGetAccountBalanceQuery,
  useUpdateProductDetailsMutation,
  useSaveProductDetailsMutation,

  useGetPurchaseTableMutation,
  useUpdatePurchaseTableMutation,
  useGetPurchaseTableHistoryMutation,

  useGetInvestmentCompaniesQuery,
  useGetInvestmentVehiclesForProductQuery,
  useGetAllInvestmentVehiclesForProductQuery,
  useLazyGetInvestmentVehiclesForProductQuery,
  useSaveProductInvestmentVehiclesMutation,
  useProductInvestmentVehiclesAuditMutation,
} = riccAPI;
